// Global
import { FC } from 'react';

// Helpers
import { getProductUrl } from '../../utils';

interface IProductLinkProps {
  siteUrl: string;
  productId: string;
}

export const ProductLink: FC<IProductLinkProps> = ({ siteUrl, productId }) => {
  const productUrl = getProductUrl(siteUrl, productId);
  return (
    <a
      onClick={(e) => e.stopPropagation()} // Prevent click event propagation to avoid modal opening
      href={productUrl}
      target="_blank"
      rel="noreferrer"
    >
      {productUrl}
    </a>
  );
};
